import * as React from 'react';
import { connect } from 'react-redux';
import { compose, withHandlers, withProps } from 'recompose';
import { reduxForm, formValueSelector } from 'redux-form';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { get } from 'lodash';
import Divider from 'material-ui/Divider';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import 'node_modules/video-react/dist/video-react.css';

import { Upload, UploadField } from '@components/form';

import * as T from '@modules/events/_eventsTypes';
import { processPhotos } from './_eventsActions';
import { withRouter } from 'react-router';

const enhance = compose<T.EventsFormProps, T.Outter & T.EventsFormProps>(
  withRouter,
  connect(state => ({
    fileRef: formValueSelector('module-events-prolaser-form')(state, 'fileRef')
  })),
  withHandlers({
    onSubmit: ({ closeItem, handleSnackbar, history }) => async formData => {
      if (get(formData, 'fileRef')) {
        const response = await processPhotos([get(formData, 'fileRef')]);
        const event = get(response, '0');

        if (event) {
          history.push(`/events?item=${get(event, 'id')}`);
        } else {
          handleSnackbar('Událost se nepodařilo vytvořit');
        }
      } else {
        closeItem();
        handleSnackbar('Něco se nepovedlo');
      }
    }
  }),
  withProps(({ initialValues }) => ({ initialValues: { fileRef: initialValues } })),
  reduxForm({
    form: 'module-events-prolaser-form'
  })
);

const View: React.SFC<T.Outter & T.EventsFormProps> = ({ handleSubmit, closeItem, fileRef }) => (
  <div>
    <form className="layout" onSubmit={handleSubmit}>
      <Grid fluid={true}>
        <Row>
          <Col className="grid-system-margin" />
        </Row>

        <Row>
          <Col md={12}>
            <Row>
              <Col md={4}>
                <h4>Soubor</h4>
              </Col>
              <Col md={8}>
                <UploadField component={Upload} name="fileRef" accept="image/*" />
              </Col>
            </Row>
            <Row style={{ height: 250 }}>
              <Col md={4}>
                <h4>Náhled</h4>
              </Col>
              <Col md={8}>
                {fileRef && fileRef.contentType.includes('image') && (
                  <img src={`/metropolis/api/files/${fileRef.id}`} alt="Náhled" height="250" />
                )}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col className="grid-system-margin" />
        </Row>
      </Grid>

      <Divider />

      <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
      <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
    </form>
  </div>
);

export const EventsGridProlaserForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsGridProlaserForm.tsx